const PROTECTED_TAG = /⟦(?:\/?T|R)\d+⟧/gu;

const DEFAULT_REGIONS: Record<string, string> = {
  en: "US",
  fr: "FR",
  de: "DE",
  es: "ES",
  it: "IT",
  ja: "JP",
  ko: "KR",
  pl: "PL",
  pt: "PT",
  zh: "CN",
};

export function countSourceWords(text: string, locale = "en-US"): number {
  const clean = text.replace(PROTECTED_TAG, " ").trim();
  if (!clean) return 0;
  if (/^(?:en|fr|de|es|it|pl|pt)(?:[-_]|$)/iu.test(locale)) {
    return clean.match(/[\p{L}\p{N}]+(?:[’'\-][\p{L}\p{N}]+)*/gu)?.length ?? 0;
  }
  try {
    const segmenter = new Intl.Segmenter(locale.replace("_", "-"), { granularity: "word" });
    return Array.from(segmenter.segment(clean)).filter((item) => item.isWordLike).length;
  } catch {
    return clean.match(/[\p{L}\p{N}]+(?:[’'\-][\p{L}\p{N}]+)*/gu)?.length ?? 0;
  }
}

export function localeFlag(locale: string): string {
  const normalized = locale.replace("_", "-");
  const language = normalized.split("-")[0]?.toLocaleLowerCase() || "";
  let region = normalized.split("-").find((part, index) => index > 0 && /^[A-Za-z]{2}$/.test(part));
  try {
    region = new Intl.Locale(normalized).region || region;
  } catch {
    // The split/default path below also supports informal locale strings.
  }
  region = (region || DEFAULT_REGIONS[language] || "").toLocaleUpperCase();
  if (!/^[A-Z]{2}$/.test(region)) return "🌐";
  return String.fromCodePoint(...Array.from(region, (letter) => 0x1f1e6 + letter.charCodeAt(0) - 65));
}
